import useStandards from "../../../http/public/useStandards";
import Option from "../../../Models/forms/Option";

export default (): Option[] =>
  useStandards().map(({ name }) => ({ label: name, value: name }));
